import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { GalleryModule } from '@ks89/angular-modal-gallery';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ThemeColorPipe } from 'src/app/core/utils/theme/theme-color.pipe';
import { SharePipesModule } from '../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { DatepickerComponent } from '../form-kit/datepicker/datepicker.component';
import { TimepickerComponent } from '../form-kit/timepicker/timepicker.component';
import { SelectSearchModule } from '../select-search/select.search.module';
import { SelectionListModule } from '../selection-list/selection-list.module';
import { PeriodDateTimePicker } from './date-period-time.component';

@NgModule({
  declarations: [PeriodDateTimePicker],
  imports: [
    CommonModule,
    DatepickerComponent,
    TimepickerComponent,
    TranslationModule,
    NgxMaterialTimepickerModule,
    SharePipesModule,
    SelectSearchModule,
    SelectionListModule,
    GalleryModule,
    MatDialogModule,
    ThemeColorPipe,
  ],
  exports: [PeriodDateTimePicker],
})
export class DatePeriodTimeModule {}
